import React, { FC } from 'react';
import './ImageMap.scss';
import { InteractiveTourProps } from '../InteractiveTourProps';
import { useInteractiveTourContext } from '../InteractiveTourContext';

const ImageMap: FC<InteractiveTourProps> = ({ content }) => {
  const { setCurrentSlide } = useInteractiveTourContext();

  const handleHotspotClick = (newSlide: string) => {
    setCurrentSlide(newSlide);
  };

  return (
    <div className="interactive-tour__slide-imagemap">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 600 400"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={content.imageAlt.props?.defaultMessage}
      >
        <image
          href={`${process.env.PUBLIC_ASSETS_URL}/${content.WIDGET_ID}/${content.image}`}
          width="100%"
          height="105%"
          preserveAspectRatio="none"
        />
        {content.hotspot?.active ? (
          <a
            href={`#${content.hotspot.location}`}
            onClick={() => handleHotspotClick(content.hotspot.location)}
            className="interactive-tour__slide-imagemap-hotspots"
            aria-hidden="true"
          >
            <circle
              className="interactive-tour__slide-imagemap-circle"
              cx={content.hotspot.x}
              cy={content.hotspot.y}
              r="7px"
              fill={content.hotspot.color}
            />
          </a>
        ) : (
          ''
        )}
      </svg>
    </div>
  );
};

export default ImageMap;
